import moment from "moment";
import {
  LOAD_DASHBOARD_DETAILS,
  LOAD_DASHBOARD_DETAILS_FAILED,
  LOAD_DASHBOARD_DETAILS_SUCCEEDED,
  LOAD_DASHBOARD_GRAPH_DETAILS_SUCCEEDED
} from "../../common/constants";
import { dashbaordFrequencies, dateFormats } from "../../utility/enums";

const initailState = {
  metrcisInfo: {
    persistentCredits: 0,
    totalPersistentCredits: 0,
    availablePersistentCredits: 0,
    todayConsumedCredits: 0,
    todayAvailableCredits: 0,
    totalVerified: 0,
    totalValid: 0,
    totalInvalid: 0,
    totalUnknown: 0
  },
  graphInfo: {
    fromDate: new moment()
      .subtract(6, "days")
      .startOf("day")
      .utc()
      .format(dateFormats.DATE_TIME_FORMAT),
    toDate: new moment()
      .endOf("day")
      .utc()
      .format(dateFormats.DATE_TIME_FORMAT),
    frequency: dashbaordFrequencies.WEEK,
    totalEmails: 0,
    totalEmailsPercent: 0,
    goodEmails: 0,
    goodEmailsPercent: 0,
    badEmails: 0,
    badEmailsPercent: 0,
    unknownEmails: 0,
    unknownEmailsPercent: 0,
    graphData: { Items: [] }
  }
};

export const dashboardReducer = (state = initailState, action) => {
  switch (action.type) {
    case LOAD_DASHBOARD_DETAILS_SUCCEEDED:
      return {
        ...state,
        metrcisInfo: action.dashboardInfo.metrcisInfo
      };
    case LOAD_DASHBOARD_GRAPH_DETAILS_SUCCEEDED:
      return {
        ...state,
        graphInfo: action.graphInfo
      };

    default:
      return state;
  }
};

// export default loginR:educer;



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/reducers.js